import * as StyledComponents from './StyledComponents';
import { IPRestrictionTemplateSideSheetDetails } from './IPRestrictionTemplateSideSheetDetails';
import { IPTemplateSideSheet } from './IPRestrictionInterface';
import FocusTrap from 'focus-trap-react';

export const IPRestrictionTemplateSideSheetBody = ({
  model,
  onSave,
  onCancel,
}: IPTemplateSideSheet): JSX.Element => {
  return (
    <FocusTrap active={true}
            focusTrapOptions={{
              clickOutsideDeactivates: true,
                            tabbableOptions: {
                                displayCheck: 'none'
                            }
                        }}>
    <StyledComponents.StyledSideSheetBodyContainer>
      <IPRestrictionTemplateSideSheetDetails
        model={model}
        onSave={onSave}
        onCancel={onCancel}
      />
    </StyledComponents.StyledSideSheetBodyContainer>
    </FocusTrap>
  );
};
